// @flow
import { isFunction } from "lodash";
import { createDispatcher } from "common/actionsBase";

type optionsType = {
    id: string,
    e: Object,
    types: Object,
    rootBindActions: Function,
    selectIsIdSelected: Function,
    selectReachedMaxSelection: Function,
    selectMultipleIdsInRange: Function,
    selectAvailableUntilMax: Function,
    selectionParams?: any[],
    multiple: boolean
};

const doSelectWithOptionalParams = (selector: Function, state: Object, selectionParams: any[]) => {
	let result = selector(state);

	if (isFunction(result)) {
		result = result(...selectionParams);
	}

	return result;
};

const checkAndHandleLimitReached = (options: optionsType, state: Object, rootActions: Object, selectionParams: any[]) => {
	const maxReached = doSelectWithOptionalParams(options.selectReachedMaxSelection, state, selectionParams);

	if (maxReached) {
		rootActions[options.types.SET_MAX_SELECT_REACHED]();
	}

	return maxReached;
};

const selectMultiple = (options: optionsType, dispatcher: Function, state: Object, rootActions: Object) => {
	const { types } = options;
	let { id, selectionParams } = options;

	selectionParams = selectionParams || [];

	let selectionIds = options.selectMultipleIdsInRange(state)(id, ...selectionParams);

	if (selectionIds.length === 1) { // user may have clicked the same item that was already selected so behave like shift wasnt pressed
		selectSingle(options, dispatcher, state, rootActions);
	} else if (selectionIds.length) {
		const availableForSelection = doSelectWithOptionalParams(options.selectAvailableUntilMax, state, selectionParams);

		if (availableForSelection) {
			selectionIds = selectionIds.slice(0, availableForSelection); // only select as far as can be selected based on max allowed
			dispatcher(types.SET_MULTI_FILE_SELECTION, { ids: selectionIds, params: selectionParams });
			rootActions[types.CLEAR_MAX_SELECT_REACHED]();
		} else {
			rootActions[types.SET_MAX_SELECT_REACHED](); // cant even select one more - max reached
		}
	}
};

const selectSingle = (options: optionsType, dispatcher: Function, state: Object, rootActions: Object) => {
	const { types } = options;
	let { id, selectionParams } = options;

	selectionParams = selectionParams || [];

	const isSelected = options.selectIsIdSelected(state)(id, ...selectionParams);

	if (!isSelected) { // if not already selected then it will be selected -need to make sure we're not already at max
		if (options.multiple && checkAndHandleLimitReached(options, state, rootActions, selectionParams)) {
			id = null; // dont allow new item to be selected if max reached
		} else if (!options.multiple) {
			dispatcher(types.CLEAR_IMAGE_SELECTION, { context: selectionParams[0] });// clear selection so only the new id will become selected
		}
	} else { // already selected so SET_FILE_SELECTION will unselect the id
		rootActions[types.CLEAR_MAX_SELECT_REACHED]();
	}

	dispatcher(types.SET_FILE_SELECTION, { id, params: selectionParams });
};

const fileSelect = (options: optionsType, dispatch: Function, getState: Function) => {
	const rootActions = options.rootBindActions(dispatch);
	const state = getState();
	const dispatcher = createDispatcher(dispatch);

	if (options.e.shiftKey && options.multiple) {
		selectMultiple(options, dispatcher, state, rootActions);
	} else {
		selectSingle(options, dispatcher, state, rootActions);
	}
};

export {
	fileSelect,
};
